import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { humanCapabilityProducts } from '../../data/home';
import { fadeUp } from '../../utils/motion';
export function HomeEcosystem() {
  return <section className="bg-surface-bg py-20 lg:py-28" data-id="element-405" data-mp="2xelgpl7kwg6k">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-406" data-mp="32c3imrn6hv52">
        <motion.h2 {...fadeUp} className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight mb-14" data-id="element-407" data-mp="32aamw7e3svbu">
          The SyNeural ecosystem
        </motion.h2>

        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-408" data-mp="29llfjqmgftrn">
          {/* Human Capability Platform */}
          <div className="lg:col-span-2 bg-white border border-line rounded-lg shadow-premium p-8 lg:p-10 flex flex-col" data-id="element-409" data-mp="2jd96lqf3n8sl">
            <div className="flex flex-wrap items-baseline justify-between gap-4 mb-3" data-id="element-410" data-mp="1lx2arl2m5z4b">
              <h3 className="font-heading font-bold text-2xl text-ink-dark" data-id="element-411" data-mp="1qwew21du6y4s">
                Human Capability Platform
              </h3>
              <a href="/human-capability" className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-teal transition-colors duration-150 whitespace-nowrap" data-id="element-412" data-mp="h4mhrh3ni9z4">
                Platform overview
                <ArrowRight size={14} data-id="element-413" data-mp="2h1i5x5zisvy" />
              </a>
            </div>
            <p className="text-ink-muted leading-relaxed max-w-2xl mb-8" data-id="element-414" data-mp="3ujsomqo2bani">
              A system for assessing and developing reasoning, civic judgment,
              resilience to manipulation, and leadership readiness.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-0 md:divide-x divide-line border-t border-line pt-8 mt-auto" data-id="element-415" data-mp="3kmnyygv0cx1y">
              {humanCapabilityProducts.map((product, index) => <div key={product.acronym} className={`flex flex-col ${index === 0 ? 'md:pr-8' : 'md:pl-8'}`} data-id="element-416" data-mp="1it89hnanpo8k" data-mpi={index}>
                  <p className="font-heading font-extrabold text-3xl text-navy" data-id="element-417" data-mp="38b53jioicifw">
                    {product.acronym}
                  </p>
                  <p className="text-sm font-medium text-ink-dark mt-1 mb-3" data-id="element-418" data-mp="3d3y928rsvut1">
                    {product.name}
                  </p>
                  <p className="text-ink-muted leading-relaxed mb-5" data-id="element-419" data-mp="2ybmongngfmup">{product.body}</p>
                  <a href={product.link} className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-teal transition-colors duration-150" data-id="element-420" data-mp="33ahgt97banrh">
                    Explore {product.acronym}
                    <ArrowRight size={14} data-id="element-421" data-mp="3i0wywf4flflf" />
                  </a>
                </div>)}
            </div>
          </div>

          {/* Semantic Knowledge Platform */}
          <div className="bg-navy-deep text-white rounded-lg p-8 lg:p-10 flex flex-col" data-id="element-422" data-mp="26l8h0261b6rh">
            <h3 className="font-heading font-bold text-2xl mb-3" data-id="element-423" data-mp="2aoxzqb012u4l">
              Semantic Knowledge Platform
            </h3>
            <p className="text-white/75 leading-relaxed mb-8" data-id="element-424" data-mp="232ssetfoc6r3">
              A configurable system for structured content, shared concepts,
              connected evidence, knowledge graphs, semantic search, and
              AI-assisted research.
            </p>
            <a href="/semantic-knowledge" className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-white hover:text-green-soft transition-colors duration-150" data-id="element-425" data-mp="28370ucl6tipn">
              Explore the platform
              <ArrowRight size={14} data-id="element-426" data-mp="1fcyf6arg0g6b" />
            </a>
          </div>
        </motion.div>

        <motion.p {...fadeUp} className="mt-14 text-2xl text-ink-dark leading-relaxed max-w-4xl" data-id="element-427" data-mp="1u5s74vnwiorv">
          Together, these efforts support a larger goal: people who can reason
          well, knowledge that can be examined and connected, and institutions
          equipped to make responsible decisions.
        </motion.p>
      </div>
    </section>;
}